import styled from 'styled-components';

export const Base = styled.div`
	height: 100vh; /* fallback for older browsers */
	height: 100svh; /* small viewport height - excludes dynamic UI */
	/* Fill available inline size inside the main content area */
	width: -webkit-fill-available;
	width: -moz-available;
	width: stretch;
	position: absolute;
	background: ${(p) => p.theme.gray[0]};
	background: linear-gradient(
		135deg,
		${(p) => p.theme.gray[0]} 0%,
		${(p) => p.theme.gray[100]} 50%,
		${(p) => p.theme.gray[0]} 100%
	);
	overflow: hidden;
	display: flex;
	flex-direction: column;
`;

export const SidebarToggle = styled.div`
	margin-left: 10px;
	margin-top: 10px;
`;

export const Content = styled.div`
	height: 100%;
	overflow-y: scroll;
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const Input = styled.div`
	// layout
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	margin-bottom: 120px;
	padding: 20px;
	width: 100%;
	max-width: 600px;

	// style
	text-align: center;
`;

export const Title = styled.div`
	font-size: 24px;
	font-weight: 500;
	color: ${(p) => p.theme.gray[1000]};
	margin-bottom: 28px;
	line-height: 1.35;
`;
